import { PlayButton as PlayButton$1 } from "../../../../../ui/play-button/component.js";
import ForwardRef from "../../../../../icons/dist/react/default/pause.js";
import ForwardRef$1 from "../../../../../icons/dist/react/default/play.js";
import ForwardRef$2 from "../../../../../icons/dist/react/default/restart.js";
import { Button } from "../../../shared/components/buttons/button.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/default-video/components/buttons/play-button.tsx
/** @jsxImportSource react */
function PlayButton({ className, ...props } = {}) {
	return /* @__PURE__ */ jsxs(PlayButton$1, {
		render: /* @__PURE__ */ jsx(Button, {}),
		className: (state) => cn("media-play-button", resolveClassName(className, state)),
		...props,
		children: [
			/* @__PURE__ */ jsx(ForwardRef$2, { className: cn("media-button-icon", "media-play-button-restart-icon") }),
			/* @__PURE__ */ jsx(ForwardRef$1, { className: cn("media-button-icon", "media-play-button-play-icon") }),
			/* @__PURE__ */ jsx(ForwardRef, { className: cn("media-button-icon", "media-play-button-pause-icon") })
		]
	});
}
//#endregion
export { PlayButton };

//# sourceMappingURL=play-button.js.map